export const GET_USER_PERSONALITY =
  'pages/coach/userManagement/singleUser/plp/getUserPersonality'
